import actions from './actions';

const {
  LISTING_LOCALS_BEGIN, LISTING_LOCALS_SUCCESS, LISTING_LOCALS_ERR,
  LISTING_LOCALS_CREATE_BEGIN, LISTING_LOCALS_CREATE_SUCCESS, LISTING_LOCALS_CREATE_ERR,
  GET_LISTING_LOCALS_BEGIN, GET_LISTING_LOCALS_SUCCESS, GET_LISTING_LOCALS_ERR,
  LISTING_LOCALS_DELETE_BEGIN, LISTING_LOCALS_DELETE_SUCCESS, LISTING_LOCALS_DELETE_ERR
} = actions;

const initState = {
  list: null,
  loading: false,
  error: null,
};

/**
 *
 * @todo impure state mutation/explaination
 */
const ListingLocalsReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LISTING_LOCALS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LISTING_LOCALS_SUCCESS:
      return {
        ...state,
        list: data,
        loading: false,
      };
    case LISTING_LOCALS_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case LISTING_LOCALS_CREATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LISTING_LOCALS_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case LISTING_LOCALS_CREATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case GET_LISTING_LOCALS_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_LISTING_LOCALS_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_LISTING_LOCALS_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case LISTING_LOCALS_DELETE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case LISTING_LOCALS_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case LISTING_LOCALS_DELETE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default ListingLocalsReducer;
